import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import PageTitle from "./PageTitleCompoent";
import "../css/ViewSubscribers.css";
import api from "../api"; // centralized axios instance

export default function ViewSubscribers() {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Get plan data passed from SubscriptionDashboard
  const plan = location.state?.plan;

  const handleBack = () => {
    navigate(-1);
  };

  if (!plan) {
    return (
      <div className="view-subscribers-container">
        <Sidebar />
        <div className="view-subscribers-main">
          <Header />
          <div className="view-subscribers-content">
            <PageTitle title="View Subscribers" onBack={handleBack} />
            <p>No plan data available.</p>
          </div>
        </div>
      </div>
    );
  }

  const subscribers = plan.my_subscribers || [];

  return (
    <div className="view-subscribers-container">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="view-subscribers-main">
        <Header />

        <div className="view-subscribers-content">
          {/* Back + Title */}
          <PageTitle
            title={`Subscribers - ${plan.subscription_duration}`}
            onBack={handleBack}
          />

          {/* Subscribers Card */}
          <div className="subscribers-card">
            <h3 className="subscribers-heading">
              {plan.subscription_duration.charAt(0).toUpperCase() +
                plan.subscription_duration.slice(1)}{" "}
              Subscribed Users
            </h3>

            <div className="subscribers-table">
              {/* Table Header */}
              <div className="table-header">
                <span>Profile</span>
                <span>Name</span>
                <span>Subscribed On</span>
                <span>Due Date</span>
              </div>

              {/* Table Rows */}
              {subscribers.length > 0 ? (
                subscribers.map((user) => (
                  <div key={user.id} className="table-row">
                    {/* Profile */}
                    <span>
                      <img
                        src={
                          user.profile_image
                        ? `${api.defaults.baseURL.split("/api")[0]}${
                            user.profile_image
                          }`
                        : "/default-avatar.png"
                        }
                        alt={user.fullName}
                        className="profile-img"
                      />
                    </span>

                    {/* Name */}
                    <span>{user.fullName}</span>

                    {/* Subscribed On */}
                    <span>{user.subscribed_on}</span>

                    {/* Due Date */}
                    <span
                      className={
                        user.due_status === "today" ? "due-today" : ""
                      }
                    >
                      {user.due_date}
                    </span>
                  </div>
                ))
              ) : (
                <p>No subscribers found for this plan.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
